// Archivo: assets/country-redirect.js
// Script universal para ambos sitios de Shopify

(function() {
    // Configuración automática basada en el dominio actual
    const currentDomain = window.location.hostname;
    const ARGENTINA_URL = 'https://www.sensationdutemps.com/';
    const URUGUAY_URL = 'https://www.sensationdutemps.com.uy/';
    
    // Determinar configuración según dominio actual
    let isUruguaySite = currentDomain.includes('.com.uy');
    let targetUrlForUruguay = URUGUAY_URL;
    let targetUrlForArgentina = ARGENTINA_URL;
    
    console.log('Sitio actual:', currentDomain, isUruguaySite ? '(Uruguay)' : '(Argentina)');
    
    // Países permitidos para navegar en el sitio de Uruguay (incluye US para Google Ads)
    const ALLOWED_COUNTRIES = ['UY', 'US'];
    
    // Páginas que NO tienen restricción de país (accesibles desde cualquier lugar)
    const NO_RESTRICTION_PAGES = [
        '/pages/omega',
        '/pages/cartier'
    ];
    
    // Función para verificar si la página actual no tiene restricciones
    function isNoRestrictionPage() {
        const currentPath = window.location.pathname;
        return NO_RESTRICTION_PAGES.includes(currentPath);
    }
    
    // Función para verificar si un país está permitido
    function isAllowedCountry(countryCode) {
        return ALLOWED_COUNTRIES.includes(countryCode);
    }
    
    // Función para construir URL completa manteniendo la página actual
    function buildTargetUrl(baseUrl) {
        const currentPath = window.location.pathname;
        const currentSearch = window.location.search;
        return baseUrl.replace(/\/$/, '') + currentPath + currentSearch;
    }
    
    // Lista de páginas excepcionales que no deben ser accedidas desde Uruguay
    const EXCEPTION_PAGES = [
        '/pages/sailgp-championship',
        '/pages/filarmonica-de-viena',
        '/pages/us-open',
        '/pages/the-open',
        '/pages/the-amundi-evian-championship',
        '/pages/wimbledon',
        '/pages/las-24-horas-de-le-mans',
        '/pages/resistencia',
        '/pages/rolex-day-date',
        '/pages/rolex-sky-dweller',
        '/pages/rolex-lady-datejust',
        '/pages/rolex-datejust',
        '/pages/rolex-oyster-perpetual',
        '/pages/rolex-cosmograph-daytona',
        '/pages/rolex-submariner',
        '/pages/rolex-sea-dweller',
        '/pages/rolex-deepsea',
        '/pages/rolex-gmt-master-ii',
        '/pages/rolex-yacht-master',
        '/pages/rolex-explorer',
        '/pages/rolex-air-king',
        '/pages/rolex-1908',
        '/pages/reloj-land-dweller',
        '/pages/watcher-dweller',
        '/pages/rolex-new-watches-gmt-master-ii',
        '/pages/land-dweller',
        '/pages/rolex-new-watches-oyster-perpetual',
        '/pages/rolex-new-watches-1908',
        '/pages/rolex-new-watches-datejust',
        '/pages/rolex-new-watches-esferas-ineditas',
        '/pages/contact-message',
        '/pages/world-of-rolex',
        '/pages/relojes-rolex',
        '/pages/rolex-new-watches-2025',
        '/pages/nuevos-modelos-2026',
        '/pages/rolex-watchmaking',
        '/pages/rolex-servicing',
        '/pages/pongase-en-contacto-con-nosotros',
        '/pages/rolex-contact',
        '/pages/rolex'
    ];

    // Función para verificar si la página actual es una excepción
    function isExceptionPage() {
        const currentPath = window.location.pathname;
        
        // Verificar si es una página de excepción
        if (EXCEPTION_PAGES.includes(currentPath)) {
            return true;
        }
        
        // Verificar si es un producto con template "lop-rolex"
        if (currentPath.startsWith('/products/')) {
            const productHandle = currentPath.split('/').pop();
            if (productHandle && productHandle.includes('lop-rolex')) {
                return true;
            }
        }
        
        return false;
    }

    // Función para detectar país usando múltiples métodos
    async function detectCountryAndRedirect() {
        // Verificar primero si es una página sin restricciones
        if (isNoRestrictionPage()) {
            console.log('Página sin restricción de país, permitiendo acceso:', window.location.pathname);
            return;
        }
        
        try {
            // Método 1: API gratuita ipapi.co (más confiable)
            const response = await fetch('https://ipapi.co/json/', {
                timeout: 5000
            });
            
            if (response.ok) {
                const data = await response.json();
                const countryCode = data.country_code;
                
                console.log('País detectado:', countryCode, data.country_name);
                
                // Lógica de redirección
                if (isAllowedCountry(countryCode)) {
                    // Usuario de Uruguay o Estados Unidos (países permitidos)
                    if (isUruguaySite) {
                        // Está en .com.uy, verificar si es página de excepción
                        if (isExceptionPage()) {
                            // Redirigir a .com (estas páginas no están disponibles para Uruguay)
                            const targetUrl = buildTargetUrl(targetUrlForArgentina);
                            console.log('Usuario de país permitido intentando acceder a página restringida, redirigiendo a .com:', targetUrl);
                            window.location.href = targetUrl;
                            return;
                        } else {
                            // Puede navegar libremente en .com.uy
                            console.log('Usuario de país permitido (' + countryCode + ') navegando libremente en .com.uy');
                            return;
                        }
                    } else {
                        // Está en .com, verificar si es página de excepción
                        if (isExceptionPage()) {
                            // Puede quedarse en .com para ver estas páginas
                            console.log('Usuario de país permitido en .com viendo página de excepción');
                            return;
                        } else {
                            // Solo redirigir a .com.uy si es de Uruguay, no si es de US
                            if (countryCode === 'UY') {
                                const targetUrl = buildTargetUrl(targetUrlForUruguay);
                                console.log('Redirigiendo uruguayo de .com a .com.uy:', targetUrl);
                                window.location.href = targetUrl;
                                return;
                            } else {
                                // Usuario de US puede quedarse en .com
                                console.log('Usuario de', countryCode, 'puede navegar en .com');
                                return;
                            }
                        }
                    }
                } else {
                    // Usuario de CUALQUIER otro país (Argentina, etc.)
                    if (isUruguaySite) {
                        // Está en .com.uy, redirigir a .com
                        const targetUrl = buildTargetUrl(targetUrlForArgentina);
                        console.log('Redirigiendo usuario de', countryCode, 'de .com.uy a .com:', targetUrl);
                        window.location.href = targetUrl;
                        return;
                    } else {
                        // Ya está en .com, todo correcto
                        console.log('Usuario de', countryCode, 'ya en sitio correcto (.com)');
                        return;
                    }
                }
            }
        } catch (error) {
            console.log('Error con método principal, intentando método alternativo:', error);
        }
        
        try {
            // Método 2: API alternativa (backup)
            const response2 = await fetch('https://api.country.is/', {
                timeout: 5000
            });
            
            if (response2.ok) {
                const data2 = await response2.json();
                const countryCode2 = data2.country;
                
                console.log('País detectado (método 2):', countryCode2);
                
                if (isAllowedCountry(countryCode2)) {
                    // Usuario de país permitido (Uruguay o Estados Unidos)
                    if (isUruguaySite) {
                        if (isExceptionPage()) {
                            const targetUrl = buildTargetUrl(targetUrlForArgentina);
                            window.location.href = targetUrl;
                            return;
                        } else {
                            return;
                        }
                    } else {
                        if (isExceptionPage()) {
                            return;
                        } else {
                            // Solo redirigir a .com.uy si es de Uruguay
                            if (countryCode2 === 'UY') {
                                const targetUrl = buildTargetUrl(targetUrlForUruguay);
                                window.location.href = targetUrl;
                                return;
                            } else {
                                return;
                            }
                        }
                    }
                } else {
                    // Usuario de CUALQUIER otro país
                    if (isUruguaySite) {
                        const targetUrl = buildTargetUrl(targetUrlForArgentina);
                        window.location.href = targetUrl;
                        return;
                    } else {
                        return;
                    }
                }
            }
        } catch (error2) {
            console.log('Error con método alternativo:', error2);
        }
        
        try {
            // Método 3: Usando timezone como fallback
            const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            console.log('Timezone detectado:', timezone);
            
            // Timezones permitidos: Uruguay y Estados Unidos
            const US_TIMEZONES = [
                'America/New_York', 'America/Chicago', 'America/Denver', 
                'America/Los_Angeles', 'America/Anchorage', 'Pacific/Honolulu',
                'America/Phoenix', 'America/Detroit', 'America/Indiana/Indianapolis'
            ];
            const isUruguayTimezone = timezone === 'America/Montevideo';
            const isUSTimezone = US_TIMEZONES.includes(timezone);
            const isAllowedTimezone = isUruguayTimezone || isUSTimezone;
            
            if (isAllowedTimezone) {
                // Usuario probablemente de Uruguay o Estados Unidos
                if (isUruguaySite) {
                    if (isExceptionPage()) {
                        const targetUrl = buildTargetUrl(targetUrlForArgentina);
                        window.location.href = targetUrl;
                        return;
                    } else {
                        return;
                    }
                } else {
                    if (isExceptionPage()) {
                        return;
                    } else {
                        // Solo redirigir a .com.uy si es de Uruguay
                        if (isUruguayTimezone) {
                            const targetUrl = buildTargetUrl(targetUrlForUruguay);
                            window.location.href = targetUrl;
                            return;
                        } else {
                            return;
                        }
                    }
                }
            } else {
                // Usuario de CUALQUIER otro timezone
                if (isUruguaySite) {
                    const targetUrl = buildTargetUrl(targetUrlForArgentina);
                    window.location.href = targetUrl;
                    return;
                } else {
                    return;
                }
            }
            
        } catch (error3) {
            console.log('Error con detección de timezone:', error3);
        }
    }
    
    // Ejecutar la detección cuando la página esté cargada
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', detectCountryAndRedirect);
    } else {
        detectCountryAndRedirect();
    }
    
})();